export default __webpack_public_path__ + "static/media/icon8white.77e3246f.svg";